enum SampleStatus {
  Unlocked = 0,
  Locked = 1
}

export default SampleStatus;
